import React, {Component, createRef} from "react";
import FancyNavigation from "../ScrollSpyPagination/PaginationNavigation";
import SectionTitle from "../SectionTitle";
import Fade from "react-reveal/Fade";
import DisplayScreens from "../DisplayScreens";
import "./FSSAdmissionStyles.css";


class FSSAdmission extends Component {
    constructor(props) {
        super(props);
        this.push = createRef();
        this.pushAnimation = this.pushAnimation.bind();
        this.state = {
            images: ['./fssAdmission/CN_ZP_1.svg', './fssAdmission/CN_ZP_1.png', './fssAdmission/CN_ZP_2.svg', './fssAdmission/CN_ZP_2.png', './fssAdmission/push (1).svg', './fssAdmission/push.png'],
            isRetina: window.devicePixelRatio >= 2
        }
    }

    pushAnimation = () => {
        let pushMessage = this.push.current;
        pushMessage.classList.add("push_transition");
    }

    render() {
        let screen1 = this.state.isRetina ? this.state.images[1] : this.state.images[0];
        let screen2 = this.state.isRetina ? this.state.images[3] : this.state.images[2];
        let screen3 = this.state.isRetina ? this.state.images[5] : this.state.images[4];
        return (
            <div id="box-hidden" className={"fssadmission"}>
                <FancyNavigation/>
                <SectionTitle title={"Записывайтесь на прием в отделения фонда"} width={70}/>
                <div className={"fssadmission-blueline-box"}>
                    <Fade right duration={5000}>
                        <div className={"fssadmission-blueline"}></div>
                    </Fade>
                </div>
                <div className={"fssadmission-container"}>
                    <div className={"fssadmission-infolist"}>
                        <div className={"fssadmission-list"}>
                            <ul className={"fssadmission-list_list"}>
                                <Fade top duration={1000} delay={500}>
                                    <li className={"fssadmission-list_item"}>Выберите услугу
                                        <div className={"fssadmission-list_item_border _first"}></div>
                                    </li>
                                </Fade>
                                <Fade top duration={1000} delay={750}>
                                    <li className={"fssadmission-list_item arrow_item"}>
                                        <img src={process.env.PUBLIC_URL + "./fssAdmission/arrow.svg"}/>
                                    </li>
                                </Fade>
                                <Fade top duration={1000} delay={1000}>
                                    <li className={"fssadmission-list_item"}>Выберите ближайшее отделение
                                        <div className={"fssadmission-list_item_border"}></div>
                                    </li>
                                </Fade>
                                <Fade top duration={1000} delay={1250}>
                                    <li className={"fssadmission-list_item arrow_item"}>
                                        <img src={process.env.PUBLIC_URL + "./fssAdmission/arrow.svg"}/>
                                    </li>
                                </Fade>
                                <Fade top duration={1000} delay={1500}>
                                    <li className={"fssadmission-list_item"}>Запишитесь на удобное время
                                        <div className={"fssadmission-list_item_border _last"}></div>
                                    </li>
                                </Fade>
                            </ul>
                        </div>
                    </div>
                    <div className={"fssadmission-screenshots"}>
                        <div className={"fssadmission-display-screen1"}>
                            <Fade delay={750}>
                                <DisplayScreens screen={screen1}/>
                            </Fade>
                        </div>
                        <div className={"fssadmission-display-screen2"} >
                            <Fade delay={1500}>
                                <DisplayScreens screen={screen2} />
                            </Fade>
                        </div>
                    </div>
                    <div className={"fssadmission-push"} ref={this.push}>
                        <Fade duration={1000} delay={1750} >
                                <img src={process.env.PUBLIC_URL + screen3} onAnimationEnd={() => this.pushAnimation()}/>
                        </Fade>
                    </div>
                </div>
            </div>
        );
    }
}

export default FSSAdmission;